import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './core/error/error.component';
import { AuthGuard } from './core/services/auth.guard';
import { TaskComponent } from './core/task/task.component';
import { WorkbenchListComponent } from './workbench/workbench-list/workbench-list.component';
import { UploadModalComponent } from './upload-workbench/upload-modal/upload-modal.component';
import { UploadMissedActionDataValidationComponent } from './upload-missed-action-data-validation/upload-missed-action-data-validation.component';
import { UploadWorkbenchHistoryComponent } from './upload-workbench/upload-workbench-history/upload-workbench-history.component';
import { UploadMissedActionDataValidationHistoryComponent } from './upload-missed-action-data-validation-history/upload-missed-action-data-validation-history.component';
import { ReviewCrawledDataListComponent } from './review-crawled-data/review-crawled-data-list/review-crawled-data-list.component';
import { UrlInstancesAndSchedulesListComponent } from './url-instances-and-schedules/url-instances-and-schedules-list/url-instances-and-schedules-list.component';
import { ReviewMissedDataListComponent } from './review-missed-data/review-missed-data-list/review-missed-data-list.component';
import { SyncRcmMasterDataComponent } from './sync-rcm-master-data/sync-rcm-master-data/sync-rcm-master-data.component';
import { GetCrawledDataComponent } from './get-crawled-data/get-crawled-data/get-crawled-data.component';
import { ManageSummaryGenerationParameterComponent } from './summary-generation-parameter/manage-summary-generation-parameter/manage-summary-generation-parameter.component';
import { QueryBuilderComponent } from './query-builder/query-builder/query-builder.component';

const routes: Routes = [
  {
    path: 'Login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'UrlConfiguration',
    loadChildren: () => import('./configuration/configuration.module').then((m) => m.ConfigurationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Workbench',
    loadChildren: () => import('./workbench/workbench.module').then((m) => m.WorkbenchModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'WorkbenchInsuranceACQ',
    loadChildren: () => import('./workbench-insurance-acq/workbench-insurance-acq.module').then((m) => m.WorkbenchInsuranceACQModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'InsuranceFormWorkbench',
    loadChildren: () => import('./workbench-insurance-form/workbench-insurance-form.module').then((m) => m.WorkbenchInsuranceFormModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'WorkbenchMCE',
    loadChildren: () => import('./workbench-mce/workbench-mce.module').then((m) => m.WorkbenchMceModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'RLSearch',
    loadChildren: () => import('./regulationlake/regulationlake.module').then((m) => m.RegulationlakeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'RLSearchInsuranceACQ',
    loadChildren: () => import('./regulationlake-insurance-acq/regulationlake-insurance-acq.module').then((m) => m.RegulationlakeInsuranceACQModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'RLSearchInsuranceForm',
    loadChildren: () => import('./regulationlake-insurance-form/regulationlake-insurance-form.module').then((m) => m.RegulationlakeInsuranceFormModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'RLSearchMCE',
    loadChildren: () => import('./regulationlake-mce/regulationlake-mce.module').then((m) => m.RegulationlakeMceModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'User',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ScheduleMaster',
    loadChildren: () => import('./schedulemaster/schedulemaster.module').then((m) => m.SchedulemasterModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Report',
    loadChildren: () => import('./report/report.module').then((m) => m.ReportModule),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'Taskmaster',
  //   loadChildren: () => import('./taskmaster/taskmaster.module').then((m) => m.TaskmasterModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'Field',
    loadChildren: () => import('./field/field.module').then((m) => m.FieldModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Upload',
    loadChildren: () => import('./upload-workbench/upload-workbench.module').then((m) => m.UploadWorkbenchModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'UploadMissedData', 
    component:UploadMissedActionDataValidationComponent,
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'UploadWorkbenchHistory',
  //   loadChildren: () => import('./upload-workbench/upload-workbench.module').then((m) => m.UploadWorkbenchModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'MissedActionDataHistory', 
    component:UploadMissedActionDataValidationHistoryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ReviewCrawledDataList', 
    component:ReviewCrawledDataListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'UrlInstancesAndSchedulesListComponent', 
    component:UrlInstancesAndSchedulesListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ReviewMissedDataListComponent', 
    component:ReviewMissedDataListComponent,
    canActivate: [AuthGuard]  
  },
  {
    path: 'SyncRcmMasterDataComponent', 
    component:SyncRcmMasterDataComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'GetCrawledDataList', 
    component:GetCrawledDataComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'RecrawlUrlConfiguration',
    loadChildren: () => import('./recrawl-url-configuration-data/recrawl-url-configuration-data-routing.module').then((m) => m.RecrawlUrlConfigurationDataRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'QueryBuilderComponent', 
    component:QueryBuilderComponent,
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'AppConfiguration',
  //   loadChildren: () => import('./app-configuration/app-configuration.module').then((m) => m.AppConfigurationModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'Error',
    component: ErrorComponent,
  },
  {
    path: 'Task',
    component: TaskComponent,
  },
  {
    path: '',
    redirectTo: 'Login',
    pathMatch: 'full'
  },
  {
    path: 'SummaryGenerationParameterMapping', 
    component:ManageSummaryGenerationParameterComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
